@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Zen+Kaku+Gothic+New:wght@500;700;900&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  /* background */
  --background-50: 0.995 0.005 122;
  --background-100: 0.972 0.013 126;
  --background-200: 0.925 0.013 140;
  --background-300: 0.872 0.013 140;
  --background-400: 0.79 0.012 140;
  --background-500: 0.69 0.012 140;
  --background-600: 0.58 0.012 145;
  --background-700: 0.47 0.012 150;
  --background-800: 0.35 0.012 155;
  --background-900: 0.26 0.013 160;
  --background-950: 0.19 0.014 165;

  /* foreground */
  --foreground-50: 0.985 0.005 160;
  --foreground-100: 0.958 0.007 160;
  --foreground-200: 0.918 0.008 160;
  --foreground-300: 0.848 0.01 165;
  --foreground-400: 0.735 0.012 165;
  --foreground-500: 0.625 0.012 165;
  --foreground-600: 0.545 0.012 165;
  --foreground-700: 0.455 0.013 168;
  --foreground-800: 0.365 0.013 168;
  --foreground-900: 0.285 0.014 170;
  --foreground-950: 0.22 0.015 170;

  /* primary : sage green */
  --primary-50: 0.978 0.02 128;
  --primary-100: 0.95 0.045 130;
  --primary-200: 0.902 0.072 132;
  --primary-300: 0.832 0.1 134;
  --primary-400: 0.762 0.12 135;
  --primary-500: 0.7 0.13 135;
  --primary-600: 0.628 0.128 136;
  --primary-700: 0.548 0.118 137;
  --primary-800: 0.462 0.1 138;
  --primary-900: 0.382 0.08 140;
  --primary-950: 0.262 0.058 142;

  /* accent : coral */
  --accent-50: 0.976 0.018 25;
  --accent-100: 0.944 0.04 25;
  --accent-200: 0.892 0.068 25;
  --accent-300: 0.82 0.11 25;
  --accent-400: 0.735 0.148 25;
  --accent-500: 0.662 0.17 25;
  --accent-600: 0.59 0.168 25;
  --accent-700: 0.512 0.15 25;
  --accent-800: 0.43 0.128 25;
  --accent-900: 0.362 0.1 25;
  --accent-950: 0.252 0.062 25;

  /* secondary : muted sage */
  --secondary-50: 0.98 0.008 150;
  --secondary-100: 0.95 0.012 150;
  --secondary-200: 0.902 0.014 150;
  --secondary-300: 0.842 0.016 150;
  --secondary-400: 0.752 0.016 155;
  --secondary-500: 0.662 0.016 160;
  --secondary-600: 0.582 0.015 162;
  --secondary-700: 0.5 0.014 165;
  --secondary-800: 0.42 0.013 165;
  --secondary-900: 0.34 0.012 168;
  --secondary-950: 0.24 0.012 170;

  --font-heading: 'Zen Kaku Gothic New', 'Noto Sans JP', system-ui, sans-serif;
  --font-body: 'Noto Sans JP', system-ui, sans-serif;
  --font-label: 'Noto Sans JP', system-ui, sans-serif;
}

.dark {
  --background-50: 0.19 0.014 165;
  --background-100: 0.23 0.014 165;
  --background-200: 0.3 0.013 163;
  --background-300: 0.38 0.012 160;
  --background-400: 0.47 0.012 155;
  --background-500: 0.57 0.012 150;
  --background-600: 0.68 0.012 145;
  --background-700: 0.78 0.012 142;
  --background-800: 0.87 0.012 140;
  --background-900: 0.93 0.012 138;
  --background-950: 0.99 0.006 130;

  --foreground-50: 0.19 0.015 170;
  --foreground-100: 0.24 0.014 170;
  --foreground-200: 0.32 0.014 168;
  --foreground-300: 0.4 0.013 168;
  --foreground-400: 0.5 0.012 166;
  --foreground-500: 0.6 0.012 165;
  --foreground-600: 0.7 0.012 165;
  --foreground-700: 0.8 0.01 163;
  --foreground-800: 0.88 0.008 162;
  --foreground-900: 0.94 0.006 160;
  --foreground-950: 0.98 0.005 158;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-body);
  background-color: oklch(var(--background-50));
  color: oklch(var(--foreground-950));
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
h4,
.font-heading {
  font-family: var(--font-heading);
  letter-spacing: 0.01em;
}

::selection {
  background-color: oklch(var(--primary-200));
  color: oklch(var(--foreground-950));
}

@keyframes rise-in {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-rise {
  animation: rise-in 0.75s cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

.animate-rise-slow {
  animation: rise-in 0.95s cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

/* スクロールで画面に入ったときに、控えめにフェードインさせる */
.reveal {
  opacity: 0;
  transform: translateY(12px);
  transition:
    opacity 0.5s cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}

/* キーボード操作でも現在位置がわかるようにする */
a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid oklch(var(--primary-600));
  outline-offset: 2px;
}

/* お問い合わせフォームの自動入力よけ入力欄（画面外に置いて非表示にする） */
.contact-alt-field {
  position: absolute;
  top: auto;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  .reveal,
  .reveal.is-visible {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .animate-rise,
  .animate-rise-slow {
    animation: none;
    opacity: 1;
    transform: none;
  }

  .delay-100,
  .delay-200,
  .delay-300,
  .delay-400 {
    animation-delay: 0s;
  }
}

.delay-100 {
  animation-delay: 0.1s;
}

.delay-200 {
  animation-delay: 0.2s;
}

.delay-300 {
  animation-delay: 0.3s;
}

.delay-400 {
  animation-delay: 0.4s;
}